import * as type from "./type";

export const getBannerListRequest = (data) => {
  return {
    type: type.GET_BANNER_LIST_REQUEST,
    payload: data,
  };
};

export const getBannerListSuccess = (data) => {
  return {
    type: type.GET_BANNER_LIST_SUCCESS,
    payload: data,
  };
};
